export default {
    PLAN: '/',
    HISTORY: '/history',
    CALENDAR_REPORT: '/launch_calendar_report',
    PRODUCTION_REPORT: '/digital_production_report',
};
